import { Link } from "react-router-dom";
import "./About.css";

export default function About() {
  return (
    <>
      <div className="page-banner">
        <h1>About Us</h1>
        <p>New Birth Church of Christ International</p>
        <nav className="breadcrumb" aria-label="breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>About</span>
        </nav>
      </div>

      {/* Mission section */}
      <section className="about-intro">
        <div className="container about-grid">
          <div className="about-img-col">
            <img
              src="/img/bishopbryan.jpeg"
              alt="Bishop Bryan"
              className="about-main-img"
            />
            <div className="about-quote-card">
              <p>
                "The vision of bringing God's people together has never left
                me."
              </p>
              <span>— Founding Bishop</span>
            </div>
          </div>
          <div className="about-text-col">
            <p className="section-label">Our Purpose</p>
            <h2 className="section-title">
              What We Are <span>All About</span>
            </h2>
            <p>
              The most important objective of New Birth Church of Christ
              International is winning souls and more souls for the Kingdom of
              heaven, to support and strengthen every pastor and the members of
              their congregations.
            </p>
            <p>
              Also to bring about a strong unification in the Body of Christ, to
              help individual churches with humanitarian needs within their
              villages, cities and countries. To help provide Spiritual guidance
              and professional counselling to every Pastor and minister of the
              body of Christ.
            </p>
            <p>
              To encourage, educate and empower the men and women of tomorrow,
              and to help every church with investments and Insurance, and for
              government and parliamentary procedure and issues. And if the
              needs arise to help with financial support.
            </p>

            <div className="about-pillars">
              {[
                "Soul Winning",
                "Church Unity",
                "Humanitarian Aid",
                "Minister Equipping",
                "Spiritual Guidance",
                "Global Fellowship",
              ].map((p) => (
                <div key={p} className="pillar-chip">
                  ✓ {p}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* History */}
      <section className="history-section">
        <div className="container">
          <div
            className="section-header-center"
            style={{ marginBottom: "3.5rem" }}
          >
            <p className="section-label">Our Story</p>
            <h2 className="section-title">
              History of <span>New Birth CCCI</span>
            </h2>
          </div>

          <div className="timeline">
            <div className="timeline-item">
              <div className="tl-dot">1985</div>
              <div className="tl-card">
                <h3>A Divine Vision</h3>
                <p>
                  In 1985, something extraordinary happened — an out-of-body
                  experience where the spirit left the body. From that
                  experience, the Lord spoke to unite all pastors together. As a
                  young minister at 27, this was a monumental task, as older
                  pastors and bishops were hesitant to follow a young minister.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="tl-dot">1987</div>
              <div className="tl-card">
                <h3>The Union of Ministries</h3>
                <p>
                  A fellowship organization called the Union of Ministries was
                  put together, though the founding minister was not allowed to
                  play any role because they said he was just a young minister
                  and not yet a Pastor or Bishop. Sadly, this union lasted only
                  two years before it fell apart.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="tl-dot">2020</div>
              <div className="tl-card">
                <h3>The Vision Returns</h3>
                <p>
                  The vision came again in 2020, this time wiser and now a
                  Bishop — having preached around the world with many pastors
                  seeking fellowship. What began as a simple fellowship soon
                  revealed that many pastors in India and Africa were not
                  properly licensed, necessitating a formal organization.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="tl-dot">2022</div>
              <div className="tl-card">
                <h3>Official Launch</h3>
                <p>
                  Despite a major setback due to the COVID-19 pandemic pushing
                  back the planned 2021 launch, New Birth Church of Christ
                  International officially launched in Toronto, Canada in August
                  2022 — with over 400 churches joining the global fellowship.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="about-gallery">
        <div className="container">
          <p className="section-label" style={{ textAlign: "center" }}>
            In Action
          </p>
          <h2
            className="section-title"
            style={{ textAlign: "center", marginBottom: "2.5rem" }}
          >
            Ministry <span>Around the World</span>
          </h2>
          <div className="gallery-grid">
            {[
              "/img/bishopindiaresizednew.jpg",
              "/img/missioninindia.jpg",
              "/img/humanitarian.JPG",
              "/img/outreach.JPG",
              "/img/trainingministers.JPG",
              "/img/newbirthbuilding.JPG",
            ].map((src, i) => (
              <div key={i} className="gallery-item">
                <img src={src} alt={`Ministry ${i + 1}`} />
                <div className="gallery-hover" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container" style={{ textAlign: "center" }}>
          <p className="section-label">Join Us</p>
          <h2 className="section-title" style={{ color: "#fff" }}>
            Be Part of Our{" "}
            <span style={{ color: "var(--gold-light)" }}>Global Family</span>
          </h2>
          <p>
            Connect with us, support our mission, or partner as a church in our
            network.
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              marginTop: "2rem",
              flexWrap: "wrap",
            }}
          >
            <Link to="/contact" className="btn-primary-gold">
              Contact Us
            </Link>
            <a
              href="https://www.paypal.com/donate"
              className="btn-outline-white"
              target="_blank"
              rel="noreferrer"
            >
              Donate Now
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
